import React from "react";
import "./App.css";
import "./index.css";
import { useLocation } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About from "./components/about_us/About";
import Products from "./components/products/Products";
import Contact from "./components/contact_us/Contact";
import Cart from "./components/cart/Cart";
import Privacy from "./components/privacy_policy/Privacy";
import Return_Policy from "./components/return_policy/Privacy";
import Refund_Policy from "./components/refund_policy/Privacy";
import Shipping_Policy from "./components/shipping_policy/Privacy";
import Profile from "./components/profile_page/Profile";
import TermCondition from "./components/terms_conditions/TermCondition";
import PaymentMethod from "./components/payment_method/PaymentMethod";
import WalletInnerPage from "./components/profile_page/wallet_rank/wallet_card/inner_pages/WalletInnerPage";
import StepForm from "./components/step_form/StepForm";
import KYC_Verified from "./components/step_form/kyc_verified/KYC_Verified";
import ProfileSettings from "./components/profile_page/profile_settings/ProfileSettings";
import ProfileEdit from "./components/profile_page/profile_settings/profile_edit/ProfileEdit";
import OrderPlaced from "./components/order_placed/OrderPlaced";
import RankRewards from "./components/profile_page/wallet_rank/rank_card/rank_rewards/RankRewards";
import OrderHistory from "./components/profile_page/order_history/OrderHistory";
import Notification from "./components/profile_page/notifications_tabs/Notifications";
import Our_Community from "./components/profile_page/our_community/Our_Community";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Login from "./components/login/Login";
import Withdraw from "./components/profile_page/wallet_rank/withdraw_earnings/Withdraw";
import UpdateBankDetails from "./components/profile_page/wallet_rank/withdraw_earnings/update_bank_details/UpdateBankDetails";
import BankDetailsUpdated from "./components/profile_page/wallet_rank/withdraw_earnings/update_bank_details/bank_details_updated/BankDetailsUpdated";
import Payment_Payout from "./components/profile_page/wallet_rank/withdraw_earnings/payment_payout_success/Payment_Payout";
import TrackShipmment from "./components/common_components/common_modal/track_shipmment/TrackShipmment";
import Signup from "./components/login/Signup";
import Wallet_History from "./components/profile_page/wallet_history/Wallet_History";

import ProtectedRoute from "./ProtectedRoute";
import Cancellation_policy from "./components/cancellation-policy/Cancellation_policy";

import PaymentSuccess from "./components/payment_status/PaymentSuccess";
import PaymentFailed from "./components/payment_status/PaymentFailed";

function App() {
  const location = useLocation();
  const hideLayoutPaths = ["/", "/signup"];
  const shouldHideLayout = hideLayoutPaths.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {!shouldHideLayout && <Header />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/about"
          element={
            <ProtectedRoute>
              <About />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Products />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <PaymentMethod />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet&earnings"
          element={
            <ProtectedRoute>
              <WalletInnerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/identityVarification"
          element={
            <ProtectedRoute>
              <StepForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kycVerified"
          element={
            <ProtectedRoute>
              <KYC_Verified />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-settings"
          element={
            <ProtectedRoute>
              <ProfileSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-profile"
          element={
            <ProtectedRoute>
              <ProfileEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-placed"
          element={
            <ProtectedRoute>
              <OrderPlaced />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rank-rewards"
          element={
            <ProtectedRoute>
              <RankRewards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-history"
          element={
            <ProtectedRoute>
              <OrderHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet-history"
          element={
            <ProtectedRoute>
              <Wallet_History />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notification"
          element={
            <ProtectedRoute>
              <Notification />
            </ProtectedRoute>
          }
        />
        <Route
          path="/our-community"
          element={
            <ProtectedRoute>
              <Our_Community />
            </ProtectedRoute>
          }
        />
        <Route
          path="/withdraw"
          element={
            <ProtectedRoute>
              <Withdraw />
            </ProtectedRoute>
          }
        />
        <Route
          path="/update-bank-details"
          element={
            <ProtectedRoute>
              <UpdateBankDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bank-details-updated"
          element={
            <ProtectedRoute>
              <BankDetailsUpdated />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-payout"
          element={
            <ProtectedRoute>
              <Payment_Payout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/track_shipmment"
          element={
            <ProtectedRoute>
              <TrackShipmment />
            </ProtectedRoute>
          }
        />

        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/return-policy" element={<Return_Policy />} />
        <Route path="/refund-policy" element={<Refund_Policy />} />
        <Route path="/shipping-policy" element={<Shipping_Policy />} />
        <Route path="/terms-conditions" element={<TermCondition />} />
        <Route path="/cancellation-policy" element={<Cancellation_policy />} />

        <Route path="/payment-success" element={<PaymentSuccess />} />

        <Route path="/payment-failed" element={<PaymentFailed />} />
      </Routes>
      {!shouldHideLayout && <Footer />}
    </>
  );
}

export default App;
